module.exports = __webpack_public_path__ + "img/prague.1368afad.jpg";